function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    showPromoModalCase(response);
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }

        $('.add-to-cart-messages').append(
            '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
            + response.message
            + '</div>'
        );

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

function getPidValue($el) {
    var pid;
    var checkIfVariation = $('div[data-attr]');
    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else if(checkIfVariation.length>0) {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    } else {
        pid = $('.product-detail:not(".bundle-item")').attr('data-pid') || $('.add-to-cart-ryk').data('pid');
    }
    return pid;
}
function showPromoModalCase(data) {
    if (data.showPromoModalCase && !data.error) {
        $('#casePromoModal').removeClass('d-none');
        $('.case-promo-modal').fadeIn();
    } else {
        $('.case-promo-modal').fadeOut();
    }
}
module.exports = {
    getChildProducts:getChildProducts,
    handlePostCartAdd:handlePostCartAdd,
    getOptions:getOptions,
    getAddToCartUrl: getAddToCartUrl,
    getChildProducts:getChildProducts,
    getPidValue:getPidValue
}
